import React from "react";
import PropTypes from "prop-types";
import MDBox from "shared/ui/Box/MDBox";
import MDTypography from "shared/ui/Typography/MDTypography";
import { alpha } from "@mui/material/styles";

export default function EditModeDaySelector({ onSelectDay }) {
  return (
    <MDBox
      onClick={onSelectDay}
      sx={{
        width: "100%",
        height: "100%",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.06),
        border: "1px dashed",
        borderColor: (theme) => alpha(theme.palette.primary.main, 0.4),
        transition: "all 0.15s ease",
        "&:hover": {
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.12),
          borderColor: "primary.main",
        },
      }}
    >
      <MDTypography
        sx={{
          fontSize: "0.7rem",
          fontWeight: 600,
          color: "primary.main",
          letterSpacing: "0.3px",
          userSelect: "none",
        }}
      >
        Seleccionar día
      </MDTypography>
    </MDBox>
  );
}

EditModeDaySelector.propTypes = {
  onSelectDay: PropTypes.func.isRequired,
};
